module.exports = __webpack_public_path__ + "static/media/slide-img-3.bf7dd0b6.png";